/* eslint-disable max-len */
import { createSvgIcon } from "@mui/material/utils";

// The land-upload progress badge glyph (Figma 3002:4198, "Group 1093": a file with an
// up arrow). The path is the design's own; only the fill is currentColor (Figma: #1f1f1f)
// so it takes the badge's glyph colour, which flips in dark mode.
export const UploadDraftIcon = createSvgIcon(
  <svg width="16" height="18.7097" viewBox="0 0 16 18.7097" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 15.9032H9V11.9976L10.6 13.4944L12 12.1613L8 8.41935L4 12.1613L5.425 13.471L7 11.9976V15.9032ZM2 18.7097C1.45 18.7097 0.979167 18.5265 0.5875 18.1601C0.195833 17.7937 0 17.3532 0 16.8387V1.87097C0 1.35645 0.195833 0.915995 0.5875 0.549597C0.979167 0.183199 1.45 0 2 0H10L16 5.6129V16.8387C16 17.3532 15.8042 17.7937 15.4125 18.1601C15.0208 18.5265 14.55 18.7097 14 18.7097H2ZM9 6.54839V1.87097H2V16.8387H14V6.54839H9Z"
      fill="currentColor"
    />
  </svg>,
  "UploadDraft"
);

export default UploadDraftIcon;
